import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    title: 'LexisNexis Portal',
    sendSnapshot: true,
    scriptLoaded: false,
};

export default createSlice({
    name: 'a11ycat',
    initialState,
    reducers: {
        setTitle: (state, action) => {
            state.title = action.payload;
            return state;
        },
        setSendSnapshot: (state, action) => {
            state.sendSnapshot = action.payload;
            return state;
        },
        setScriptLoaded: (state, action) => {
            state.scriptLoaded = action.payload;
            return state;
        }
    }
});
